<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__channels}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.name" filterable clearable placeholder="渠道名称">
            <el-option
                    v-for="(item,index) in channelsList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.operationNames" filterable clearable placeholder="代运营机构">
            <el-option
                    v-for="(item,index) in operationNamesList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:channels:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:channels:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="渠道名称" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="repeatFlag" label="去重" header-align="center" align="center" >
          <template slot-scope="scope">
	            <el-tag v-if="scope.row.repeatFlag === 0" type="danger" size="small">不去重</el-tag>
	            <el-tag v-if="scope.row.repeatFlag === 1" size="small">去重</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="operationNames" label="代运营机构" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="url" label="回传URL" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="token" label="回传token" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.status === 0" type="danger" size="small">停用</el-tag>
	            <el-tag v-if="scope.row.status === 1" size="small">正常</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="creatorName" label="创建人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateName" label="更新人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:channels:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:channels:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './channels-add-or-update'
import { institution , getChannels } from '../../../api/list'
export default {
  mixins: [mixinViewModule],
 async created(){
 let res = await institution()
    if(res.data.code == 0){
      console.log(res.data.data)
     this.operationNamesList = res.data.data.list.map(item => ({value:item.id,label:item.name,}))
    }else{
      this.$mesage.error(res.data.msg)
    }

    this.channelsList = []
     let res1 = await getChannels()
     if(res.data.code == 0){
      console.log(res1.data.data)
      this.channelsList = res1.data.data.list.map(item => ({value:item.name,label:item.name}))
     }else{
      this.$message.error(res.data.msg)
     }
    
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/channels/page',
        getDataListIsPage: true,
        exportURL: '/sys/channels/export',
        deleteURL: '/sys/channels',
        deleteIsBatch: true
      },
      channelsList:[],
      operationNamesList:[],
      dataForm: {
        id: '',
        operationNames:'',
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
